import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useState } from 'react';
import classNames from 'classnames/bind';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Button } from '@carnica/ui-kit';
import { IconArrowsLeft, IconArrowsRight } from '@carnica/graphics';
import PropTypes from 'prop-types';
import { enhancedConnect } from "../../../../utils";
import styles from "./styles.pcss";
import 'swiper/css';
var cx = classNames.bind(styles);
var _VideoCarousel = function _VideoCarousel(_ref) {
  var _ref$spaceBetween = _ref.spaceBetween,
    spaceBetween = _ref$spaceBetween === void 0 ? 60 : _ref$spaceBetween,
    withOverlay = _ref.withOverlay,
    children = _ref.children,
    centeredSlides = _ref.centeredSlides,
    slidesOffsetBefore = _ref.slidesOffsetBefore,
    slidesOffsetAfter = _ref.slidesOffsetAfter,
    slideWidth = _ref.slideWidth,
    className = _ref.className;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    SwiperInstance = _useState2[0],
    setSwiperInstance = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    progress = _useState4[0],
    setProgress = _useState4[1];
  var setInstance = useCallback(function (swiper) {
    setSwiperInstance(swiper);
    setProgress(swiper.progress);
  }, []);
  var nextSlide = useCallback(function () {
    SwiperInstance === null || SwiperInstance === void 0 ? void 0 : SwiperInstance.slideNext();
  }, [SwiperInstance]);
  var prevSlide = useCallback(function () {
    SwiperInstance === null || SwiperInstance === void 0 ? void 0 : SwiperInstance.slidePrev();
  }, [SwiperInstance]);
  return /*#__PURE__*/React.createElement("div", {
    className: cx('carousel', className),
    "data-t-id": "components-VideoCarousel"
  }, withOverlay && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cx('carousel-arrow', 'arrow-prev')
  }, progress > 0 && /*#__PURE__*/React.createElement(Button, {
    className: cx('arrow-button', 'arrow-prev__button'),
    iconLeft: IconArrowsLeft,
    onClick: prevSlide,
    onlyIcon: true,
    view: "secondary"
  })), /*#__PURE__*/React.createElement("div", {
    className: cx('overlay', 'overlay-left')
  })), /*#__PURE__*/React.createElement(Swiper, {
    onSlideChange: setInstance,
    onSwiper: setInstance,
    slidesOffsetAfter: slidesOffsetAfter,
    slidesOffsetBefore: slidesOffsetBefore,
    slidesPerView: 'auto',
    spaceBetween: spaceBetween,
    centeredSlides: centeredSlides
  }, React.Children.map(children, function (child) {
    return /*#__PURE__*/React.createElement(SwiperSlide, {
      style: {
        width: slideWidth
      }
    }, child);
  })), withOverlay && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cx('overlay', 'overlay-right')
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('carousel-arrow', 'arrow-next')
  }, progress !== 1 && /*#__PURE__*/React.createElement(Button, {
    className: cx('arrow-button', 'arrow-next__button'),
    iconLeft: IconArrowsRight,
    onClick: nextSlide,
    onlyIcon: true,
    view: "secondary"
  }))));
};
export var VideoCarousel = enhancedConnect({
  children: PropTypes.node,
  spaceBetween: PropTypes.number,
  slidesOffsetAfter: PropTypes.number,
  slidesOffsetBefore: PropTypes.number,
  slideWidth: PropTypes.number,
  centeredSlides: PropTypes.bool,
  withOverlay: PropTypes.bool
})(_VideoCarousel);